<template>
  <v-col v-if="ram">
    <v-card
        class="pa-2"
        outlined
        tile
    >
      <h2 class="subtitle-1">Ram</h2>
      <v-list two-line>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ ram.total }} G</v-list-item-title>
            <v-list-item-subtitle>Total</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content>
            <v-list-item-title>{{ ram.used }} G</v-list-item-title>
            <v-list-item-subtitle>Used</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "ram",
  props: {
    ram: {
      required: true,
      type: Object,
    }
  }
}
</script>
